
<div class="web-center" style="max-width: 1520px; margin: 0 auto;">

    <div [style]="isDesktop ? 'width: 90%; max-width: 1020px; display: flex; align-items: center; flex-direction: column;': 'width: 96%; overflow-x: hidden; min-height:30px'">

        <app-meals-search-bar *ngIf="!loading"
            [isMobile]="isMobile"
            [meals]="allMeals"
            [selectedTagId]="selectedTag"
            [selectedCategoryIds]="selectedCategories"
            (selectedTagChange)="onMealsSearchChange($event)"
            (selectedCategoryChange)="onMealsSearchChange($event)"
            (searchChange)="onMealsSearchChange($event)"
            (searchReset)="resetSearch()">
        </app-meals-search-bar>

        <div>
            <ngx-spinner name="mealsSpinner" type="ball-spin-clockwise" bdColor="rgb(249, 249, 251)" size="medium" color="#ef870a" [fullScreen]="false" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;"></ngx-spinner>
            <div class="meal-grid mt-4 mb-5" *ngIf="visualMeals.length>0">
                <app-new-meal-card
                    *ngFor="let meal of visualMeals"
                    [meal]="meal"
                    (addMeal)="addMeal($event)"
                    (decreaseQuantity)="decreaseCount($event)"
                    (increaseQuantity)="increaseCount($event)"
                    (removeMeal)="removeMeal($event)">
                </app-new-meal-card>
            </div>

            <div *ngIf="visualMeals.length==0 && !loading" class="d-flex flex-direction-column align-items-center">
                <span class="mb-4 mt-5">No meals found</span>
                <button class="btn btn-primary btn-add-to-cart weight-500 fm-prompt mb-4" (click)="resetSearch()">Clear search</button>
            </div>
        </div>
    </div>
</div>


<div class="footer-custom-select-meals" *ngIf="!loading">
    <div class="footer-custom-select-meals-inner-container">
        
        <div class="footer-custom-select-meals-summary">
            <div class="footer-custom-select-meals-total-elements">
                <span class="footer-custom-select-meals-total-elements-week">{{getTotalElementsWeek()}}</span><span>/ {{getExpectedMealsWeeklyTotalCount()}}</span>
            </div>

            <!-- Grid -->
            <div class="footer-custom-select-meals-grid footer-custom-select-meals-grid-mobile">
                <div *ngFor="let row of getSelectedMealsRows()" class="circleIcon-container">
                    <div *ngFor="let item of row" [ngClass]="item ? 'circleIcon-fill' : 'circleIcon'"></div>
                </div>

            </div>

            <!-- Meals Summary -->
            <div class="footer-custom-select-meals-meals-selected">
                <div class="meals-label-wrapper">
                    <span>meals</span>
                    <span class="selected-meals-footer-summary-label">selected
                        <span class="pi" style="cursor: pointer;"
                            (click)="showCheckoutDetails('selectedMeals')"
                            [ngClass]="selectedMealsTrigger ? 'pi-angle-up' : 'pi-angle-down'">
                        </span>
                    </span>
                </div>
                <div *ngIf="selectedMealsTrigger">
                    <div *ngFor="let item of oneWeekMeals" class="mb-1 selected-meals-list">
                        <span style="cursor: pointer;" (click)="removeMeal(item)" class="remove-meal">
                            <i class="pi pi-times mx-1 fs08"></i>
                        </span>&nbsp;
                        <span style="margin-right: 1rem;font-style: italic;">{{item.name}}</span>
                        <span class="fm-rubik weight-500" style="float: right;">×{{item.count}}</span>
                    </div>                       
                </div>
            </div>
            
        </div>
            
        <!-- Grid -->
        <div class="footer-custom-select-meals-grid footer-custom-select-meals-grid-desktop">
            <div *ngFor="let row of getSelectedMealsRows()" class="circleIcon-container">
                <div *ngFor="let item of row" [ngClass]="item ? 'circleIcon-fill' : 'circleIcon'"></div>
            </div>

        </div>

            <div class="footer-custom-select-meals-price-container">
                <div class="footer-custom-select-meals-price">
                    <span *ngIf="!amountTrigger">You pay:</span>
                    <div>
                        <span *ngIf="!amountTrigger">£{{getTotalVisual()}}</span>
                        <i class="pi" style="cursor: pointer;"
                            (click)="showCheckoutDetails('amount')"
                            [ngClass]="amountTrigger ? 'pi-angle-up' : 'pi-angle-down'"></i>
                    </div>
                </div>
                <div *ngIf="amountTrigger" class="price-breakdown">
                    <div>
                        <span class="total-price-label">Sub Total</span>
                        <span>£{{getSubTotalVisual()}}</span>
                    </div>
                    <p-divider></p-divider>
                    <div *ngIf="+getDiscountVisual() > 0">
                        <span class="total-price-label">Discount</span>
                        <span>-£{{getDiscountVisual()}}</span>
                    </div>
                    <p-divider *ngIf="+getDiscountVisual() > 0"></p-divider>
                    <div>
                        <span class="total-price-label">Delivery Fees</span>
                        <span>{{deliveryFees == 0 ? 'FREE' : '+£' + deliveryFees}}</span>
                    </div>
                    <p-divider></p-divider>
                    <div>
                        <span class="total-price-label" style="font-weight: 500;color: #2C2C30;">Total<span
                                *ngIf="planOrderDetails.type!='Flexi' && !promo_discount_object"> per week</span></span>
                        <span style="font-weight: 500;color: #2C2C30;">£{{getTotalVisual()}}</span>
                    </div>
                </div>
            </div>

            <div class="checkout-button-box">
                <button (click)="goToCart()" class="checkout-button"
                    [disabled]="getTotalElementsWeek() < getExpectedMealsWeeklyTotalCount()">
                    <span>Confirm</span>
                    <span class="price-button"> | £{{getTotalVisual()}}</span>
                </button>
            </div>

            
            
            
        

    </div>
</div>

